/** Team changes reset match state; restore the requested match after that reset. */
export async function selectMatchContext(
  matchId: string,
  context: {
    selectMatch: (id: string) => Promise<void>;
    readMatch: () => { id: string; team_id: string } | null;
    readTeamId: () => string | null;
    hasTeam: (id: string) => boolean;
    selectTeam: (id: string) => void;
    cancelled: () => boolean;
  },
): Promise<void> {
  await context.selectMatch(matchId);
  if (context.cancelled()) return;
  const match = context.readMatch();
  if (!match || match.id !== matchId) throw new Error('Match selection could not be restored');
  if (context.readTeamId() !== match.team_id) {
    if (!context.hasTeam(match.team_id)) throw new Error('Match team is unavailable');
    context.selectTeam(match.team_id);
    if (!context.cancelled()) await context.selectMatch(matchId);
  }
}
